export function canAccessContent(requires, user) {
  if (!requires) {
    return true;
  }

  const modules = requires.modules || [];
  const regionalTypes = requires.regional_types || [];
  const onlyDiretor = !!requires.only_diretor;

  if (modules.length === 0 && regionalTypes.length === 0 && !onlyDiretor) {
    return true;
  }

  if (user && user.modules && modules.some((m) => user.modules[m] === "active")) {
    return true;
  }

  if (user && regionalTypes.includes(user.regional_type)) {
    return true;
  }

  if (onlyDiretor && user && user.diretor === "Y") {
    return true;
  }

  return false;
}
